import { freeze } from '@reduxjs/toolkit';
import { IBuilderBreakdown, IBuilderBreakdownGroup } from './types';
import { Order } from '../../../../utils/apollo/graphqlSchema';

export const defaultBreakdownGroup = freeze<IBuilderBreakdownGroup>(
  {
    field: null,
    filter: null,
    binning: null,
  },
  true,
);

export const defaultBreakdown = freeze<IBuilderBreakdown>(
  {
    groups: [],
    order: Order.Desc,
    overall: false,
  },
  true,
);
